// extracted by mini-css-extract-plugin
module.exports = {"root":"HexagonalButton-module__root__2xggo","image":"HexagonalButton-module__image__3PCG5","image-shadow":"HexagonalButton-module__image-shadow__3rd2y"};